import src from "IMAGE";
export default { src, width: 523, height: 93, blurWidth: 0, blurHeight: 0};
